import { render, staticRenderFns } from "./ChangeArchiveTesting.vue?vue&type=template&id=a2832a06"
import script from "./ChangeArchiveTesting.vue?vue&type=script&lang=ts"
export * from "./ChangeArchiveTesting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports